// extracted by mini-css-extract-plugin
module.exports = {"paper":"Manual_paper__3BCXB","divider":"Manual_divider__2PM81","header":"Manual_header__2nxzD"};